import Lessons from './Lessons.vue';

export default Lessons;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/views/lessons/index.ts